import { Col, Row, Space, Button, Flex, DatePicker as AntdDatePicker } from "antd";
import { Form, Formik } from "formik";

import { DatePicker, Input, Select } from "components/form";
import ApproveStatusOption from "components/elements/Select/ApproveStatusDropdown";
import ApproveStatusOptionMovement from "components/elements/Select/ApproveStatusForMovement";

import styles from "../styles/PendingApprovalFilter.module.css";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useRef, } from "react";
import DateRangePicker from "components/form/DatePicker/RangePicker";

const PendingApprovalFilter = ({
    initialValues = {},
    dataFlag = " ",
    onSubmit = () => { },
    leaveGroupOptions = [],
    employeeOptions = [],
    offsiteOptions = [],
    movementGroupOptions = [],
    documentTypeOptions = [],
}) => {
    const { t } = useTranslation();
    const { modifiedStatus = [] } = ApproveStatusOption()
    const { modifiedStatusMovement = [] } = ApproveStatusOptionMovement()

    const workingDayPickerRef = useRef(null);
    const leaveDatePickerRef = useRef(null);
    const requestApproveDatePickerRef = useRef(null);
    const offsiteWorkDatePickerRef = useRef(null);

    function formatDate(dateString, pattern = "DD-MM-YYYY") {
        // console.log("dateString", dateString);
        if (!dateString) return;
        const date = dayjs(dateString, pattern);
        return date.format("DD-MM-YYYY");
    }

    console.log('menu', dataFlag);
    function formatDate(dateString, pattern = "DD-MM-YYYY") {
        // console.log("dateString", dateString);
        if (!dateString) return;
        const date = dayjs(dateString, pattern);
        return date.format("DD-MM-YYYY");
    }

    const shiftTypeOptions = [
        {
            value: "SWAP",
            label: t('changeshift.swap')
        },
        {
            value: "CHANGESHIFT",
            label: t('changeshift.label.changeshift')
        }
    ]

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
                console.log("🚀 ~ values:", values)
                onSubmit({
                    ...values,

                });
            }}
        >
            {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
                return (
                    <Form>
                        {dataFlag == "PendingApprovalLeaveTable" && (
                            <Row gutter={[24, 16]} className={styles.filter} >
                                <Col span={12}>
                                    <Input
                                        name="reqId"
                                        label={t('reqid')}
                                        placeholder={t('reqid')}
                                        size="large"
                                    />
                                </Col>
                                <Col span={12}>
                                    <Select
                                        name="employeeId"
                                        label={t('name-surname')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Flex vertical style={{ gap: "8px" }}>
                                        <label>{t('leave-date')}</label>
                                        <DateRangePicker
                                            name="leaveDate"
                                            placeholder={t('please-select-1')}
                                            size="large"
                                            format={formatDate()}
                                            ref={leaveDatePickerRef}
                                            onChange={(dates) => {
                                                setFieldValue('leaveDate', dates);
                                            }}
                                            value={values.leaveDate}
                                        />
                                    </Flex>
                                </Col>
                                <Col span={12}>
                                    <Flex vertical style={{ gap: "8px" }}>
                                        <label>{t('request-approve-date')}</label>
                                        <DateRangePicker
                                            name="requestApproveDate"
                                            placeholder={t('please-select-1')}
                                            size="large"
                                            format={formatDate()}
                                            ref={requestApproveDatePickerRef}
                                            onChange={(dates) => {
                                                setFieldValue('requestApproveDate', dates);
                                            }}
                                            value={values.requestApproveDate}
                                        />
                                    </Flex>
                                </Col>
                                {/* <Col span={12}>
                                    <Select
                                        name="statusFlag"
                                        label={t('translation.status')}
                                        placeholder={t('translation.status')}
                                        size="large"
                                        options={modifiedStatus}
                                    />
                                </Col> */}
                            </Row>)}
                        {dataFlag == "PendingApprovalOffsiteWorkTable" && (
                            <Row gutter={[24, 16]} className={styles.filter} >
                                <Col span={12}>
                                    <Input
                                        name="reqId"
                                        label={t('reqid')}
                                        placeholder={t('reqid')}
                                        size="large"
                                    />
                                </Col>
                                <Col span={12}>
                                    <Select
                                        name="employeeId"
                                        label={t('name-surname')}
                                        placeholder={t('name-surname')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Flex vertical style={{ gap: "8px" }}>
                                        <label>{t('offsite-work-date')}</label>
                                        <DateRangePicker
                                            name="offsiteWorkDate"
                                            placeholder={t('please-select-1')}
                                            size="large"
                                            format={formatDate()}
                                            ref={offsiteWorkDatePickerRef}
                                            onChange={(dates) => {
                                                setFieldValue('offsiteWorkDate', dates);
                                            }}
                                            value={values.offsiteWorkDate}
                                        />
                                    </Flex>
                                </Col>
                                <Col span={12}>
                                    <Flex vertical style={{ gap: "8px" }}>
                                        <label>{t('request-approve-date')}</label>
                                        <DateRangePicker
                                            name="requestApproveDate"
                                            placeholder={t('please-select-1')}
                                            size="large"
                                            format={formatDate()}
                                            ref={requestApproveDatePickerRef}
                                            onChange={(dates) => {
                                                setFieldValue('requestApproveDate', dates);
                                            }}
                                            value={values.requestApproveDate}
                                        />
                                    </Flex>
                                </Col>
                                {/* <Col span={12}>
                                    <Select
                                        name="statusFlag"
                                        label={t('translation.status')}
                                        placeholder={t('translation.status')}
                                        size="large"
                                        options={modifiedStatus}
                                    />
                                </Col> */}
                            </Row>
                        )}

                        {dataFlag == "PendingApprovalRedeemTimeTable" && (
                            <Row gutter={[24, 16]} className={styles.filter} >
                                <Col span={12}>
                                    <Select
                                        name="employeeId"
                                        label={t('name-surname')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <DatePicker
                                        name="startDate"
                                        label={t('start-date')}
                                        placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                                        size="large"
                                        format={formatDate()}
                                    />
                                </Col>
                                {/* <Col span={12}>
                                    <Select
                                        name="statusFlag"
                                        label={t('translation.status')}
                                        placeholder={t('translation.status')}
                                        size="large"
                                        options={modifiedStatus}
                                    />
                                </Col> */}
                            </Row>

                        )}
                        {dataFlag == "PendingApprovalEndorseTimeTable" && (
                            <Row gutter={[24, 16]} className={styles.filter} >
                                <Col span={12}>
                                    <Select
                                        name="employeeId"
                                        label={t('name-surname')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <DatePicker
                                        name="endorseDate"
                                        label={t('pending_approval_endorse_time.label.endorse_date')}
                                        placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                                        size="large"
                                        format={formatDate()}
                                    />
                                </Col>
                                {/* <Col span={12}>
                                    <Select
                                        name="statusFlag"
                                        label={t('translation.status')}
                                        placeholder={t('translation.status')}
                                        size="large"
                                        options={modifiedStatus}
                                    />
                                </Col> */}
                            </Row>

                        )}
                        {dataFlag == "PendingApprovalOvertimeTable" && (
                            <Row gutter={[24, 16]} className={styles.filter} >
                                <Col span={12}>
                                    <Input
                                        name="reqId"
                                        label={t('reqid')}
                                        placeholder={t('reqid')}
                                        size="large"
                                    />
                                </Col>
                                <Col span={12}>
                                    <Select
                                        name="employeeId"
                                        label={t('name-surname')}
                                        placeholder={t('name-surname')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Flex vertical style={{ gap: "8px" }}>
                                        <label>{t('working-days')}</label>
                                        <DateRangePicker
                                            name="workingDay"
                                            placeholder={t('please-select-1')}
                                            size="large"
                                            format={formatDate()}
                                            ref={workingDayPickerRef}
                                            onChange={(dates) => {
                                                setFieldValue('workingDay', dates);
                                            }}
                                            value={values.workingDay}
                                        />
                                    </Flex>
                                </Col>
                                <Col span={12}>
                                    <Flex vertical style={{ gap: "8px" }}>
                                        <label>{t('request-approve-date')}</label>
                                        <DateRangePicker
                                            name="requestApproveDate"
                                            placeholder={t('please-select-1')}
                                            size="large"
                                            format={formatDate()}
                                            ref={requestApproveDatePickerRef}
                                            onChange={(dates) => {
                                                setFieldValue('requestApproveDate', dates);
                                            }}
                                            value={values.requestApproveDate}
                                        />
                                    </Flex>
                                </Col>
                                {/* <Col span={12}>
                                    <Select
                                        name="statusFlag"
                                        label={t('translation.status')}
                                        placeholder={t('translation.status')}
                                        size="large"
                                        options={modifiedStatus}
                                    />
                                </Col> */}
                            </Row>

                        )}
                        {dataFlag == "PendingApprovalCollectTimeTable" && (
                            <Row gutter={[24, 16]} className={styles.filter} >
                                <Col span={12}>
                                    <Select
                                        name="employeeId"
                                        label={t('name-surname')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <DatePicker
                                        name="startDate"
                                        label={t('start-date')}
                                        placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                                        size="large"
                                        format={formatDate()}
                                    />
                                </Col>
                                <Col span={12}>
                                    <DatePicker
                                        name="endDate"
                                        label={t('changeshift.label.enddate')}
                                        placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                                        size="large"
                                        format={formatDate()}
                                    />
                                </Col>
                                {/* <Col span={12}>
                                    <Select
                                        name="statusFlag"
                                        label={t('translation.status')}
                                        placeholder={t('translation.status')}
                                        size="large"
                                        options={modifiedStatus}
                                    />
                                </Col> */}
                            </Row>

                        )}
                        {dataFlag == "PendingApprovalExpenseTable" && (
                            <Row gutter={[24, 16]} className={styles.filter} >
                                <Col span={12}>
                                    <Select
                                        name="employeeId"
                                        label={t('name-surname')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                {/* <Col span={12}>
                                    <Input
                                        name="subject"
                                        label={t('expense.subject')}
                                        placeholder={t('userList.label.newName')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col> */}
                                <Col span={12}>
                                    <DatePicker
                                        name="transactionDate"
                                        label={t('pending_approval_expense.label.transaction_date')}
                                        placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                                        size="large"
                                        format={formatDate()}
                                    />
                                </Col>
                                {/* <Col span={12}>
                                    <Select
                                        name="statusFlag"
                                        label={t('translation.status')}
                                        placeholder={t('translation.status')}
                                        size="large"
                                        options={modifiedStatus}
                                    />
                                </Col> */}
                            </Row>

                        )}
                        {dataFlag == "Movement" && (
                            <Row gutter={[24, 16]} className={styles.filter} >
                                <Col span={12}>
                                    <Select
                                        name="employeeId"
                                        label={t('name-surname')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Select
                                        name="movementType"
                                        label={t('employment.label.movement_type')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={movementGroupOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <DatePicker
                                        name="effectiveDate"
                                        label={t('employeeShift.table.effectiveDate')}
                                        placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                                        size="large"
                                        format={formatDate()}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Select
                                        name="statusFlag"
                                        label={t('translation.status')}
                                        placeholder={t('translation.status')}
                                        size="large"
                                        options={modifiedStatusMovement}
                                    />
                                </Col>
                            </Row>
                        )}

                        {dataFlag == "RequestForm" && (
                            <Row gutter={[24, 16]} className={styles.filter}>
                                <Col span={12}>
                                    <Select
                                        name="documentTypeId"
                                        label={t('document_request.label.document_form_type')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={documentTypeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Select
                                        name="employeeId"
                                        label={t('name-surname')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <DatePicker
                                        name="submissionDate"
                                        label={t('document_request.label.submission_date')}
                                        placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                                        size="large"
                                        format={formatDate()}
                                    />
                                </Col>
                            </Row>
                        )}

                        {dataFlag == "ChangeShift" && (
                            <Row gutter={[24, 16]} className={styles.filter}>
                                <Col span={12}>
                                    <Select
                                        name="shiftType"
                                        label={t('shift.label.shift_type')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={shiftTypeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <Select
                                        name="warnedEmployeeId"
                                        label={t('name-surname')}
                                        placeholder={t('common.pleaseSelect')}
                                        size="large"
                                        options={employeeOptions}
                                    />
                                </Col>
                                <Col span={12}>
                                    <DatePicker
                                        name="startDate"
                                        label={t('start-date')}
                                        placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                                        size="large"
                                        format={formatDate()}
                                    />
                                </Col>
                            </Row>
                        )}
                        {/* {dataFlag == "WarningLetter" && (
                            <Row gutter={[24, 16]} className={styles.filter} >
                                <Col span={12}>
                                    <Input
                                        name="sequence"
                                        size="large"
                                        label={t("expense.expense-detail.request-id")}
                                        placeholder={t("common.please_fill")}
                                        allowClear
                                    />
                                </Col>
                                <Col span={12}>
                                    <Input
                                        name="warnedEmployeeName"
                                        label={t('warning_letter.label.employee')}
                                        placeholder={t('common.please_fill')}
                                        size="large"
                                        allowClear
                                    />
                                </Col>
                                <Col span={8}>
                              <Input
                                name="department"
                                label="Department"
                                placeholder="Department"
                                size="large"
                              />
                            </Col>
                                <Col span={12}>
                                    <DatePicker
                                        name="incidentDate"
                                        label={t('my_request.label.incident-date')}
                                        placeholder={t('common.placeholder.ddmmyyyy') + " *"}
                                        size="large"
                                    />
                                </Col>
                                <Col span={12}>
                                    <Select
                                        name="statusFlag"
                                        label={t('translation.status')}
                                        placeholder={t('translation.status')}
                                        size="large"
                                        options={modifiedStatus}
                                    />
                                </Col>
                            </Row>
                        )} */}

                        <Row justify="end">
                            <Space size={12} className={styles.filterbtn}>
                                <Button type="default" onClick={resetForm} style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}>
                                    {t('cancel-1').toUpperCase()}
                                </Button>
                                <Button type="primary" htmlType="submit" style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}>
                                    {t("creatTamplete.Search").toUpperCase()}
                                </Button>
                            </Space>
                        </Row>
                    </Form>
                );
            }}

        </Formik>
    )
};

export default PendingApprovalFilter;
